var _style, _path, _path2, _rect, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriclampConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.triclampConnector-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n\t.triclampConnector-st1{fill:#FFFFFF;stroke:currentColor;stroke-linejoin:bevel;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "triclampConnector-st0",
    d: "M64.7,7.1l-2.9,0c-8,0-14.5,14.8-14.5,33.1s6.4,33.1,14.5,33.1l2.9,0V7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "triclampConnector-st0",
    d: "M13.8,40.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 24.5,
    width: 10.7,
    height: 31.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "triclampConnector-st1",
    d: "M47.3,32.9l-27.9-0.1l0.1,14.7c3.2,0,24.5,0.1,27.8,0.1L47.3,32.9z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7,
    y: 7.1,
    className: "triclampConnector-st0",
    width: 4.4,
    height: 66.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriclampConnector);
export default __webpack_public_path__ + "static/media/triclampConnector.eb31ccab33dddf4bdba58424a5225178.svg";
export { ForwardRef as ReactComponent };